import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import {ComponentType} from '@angular/cdk/overlay';
import { MedicineListDialogComponent } from "./medicine-list-dialog/medicine-list-dialog.component";
import { NewPrescriptionMedicines } from "../../modules/patients/shared/models/prescription.model";

@Injectable()
export class MedicineListDialogService {
  
  constructor(private dialog: MatDialog) {
  }
  
  openDialog(component: ComponentType<any>, config?: MatDialogConfig): MatDialogRef<any> {
		return this.dialog.open(component, config);
	}

	openConfirmationDialog(message: string, options?: { leftButtonText?: string, rightButtonText?: string, hideLeftButton?: boolean, hideRightButton?: boolean, disableClose?: boolean, invertButtonColors?: boolean, medicines: Array<any> }): MatDialogRef<MedicineListDialogComponent> {
		const config: MatDialogConfig = {
			role: 'alertdialog',
			panelClass: 'confirmation-dialog',
			disableClose: options?.disableClose
		};
		const dialogRef: MatDialogRef<MedicineListDialogComponent> = this.openDialog(MedicineListDialogComponent, config);
		dialogRef.componentInstance.message = message;
		dialogRef.componentInstance.onLeftButtonClick = () => dialogRef.close();
		dialogRef.componentInstance.onRightButtonClick = () => dialogRef.close();
		dialogRef.componentInstance.hideLeftButton = options?.hideLeftButton;
		dialogRef.componentInstance.hideRightButton = options?.hideRightButton;
		dialogRef.componentInstance.invertButtonColors = options?.invertButtonColors;
		dialogRef.componentInstance.medicines = options.medicines;
		
		if (options) {
			if (options.leftButtonText) {
				dialogRef.componentInstance.leftButtonText = options.leftButtonText;
			}
			if (options.rightButtonText) {
				dialogRef.componentInstance.rightButtonText = options.rightButtonText;
			}
		}
		return dialogRef;
	}

	closeAllDialogs(): void {
		this.dialog.closeAll();
	}
}